import { useCallback, useEffect, useState } from "react";
import { App } from "antd";
import { fetchProducts, deleteProduct } from "../api";

export default function useProducts() {
  const { message } = App.useApp();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      setProducts(await fetchProducts());
    } catch (error) {
      console.error(error);
      message.error("Error al obtener los productos");
    } finally {
      setLoading(false);
    }
  }, [message]);

  const remove = useCallback(
    async (id) => {
      try {
        await deleteProduct(id);
        message.success("Producto eliminado");
        reload();
      } catch (error) {
        console.error(error);
        message.error("Error al eliminar producto");
      }
    },
    [message, reload]
  );

  useEffect(() => {
    reload();
  }, [reload]);

  return { products, loading, reload, remove };
}
